<template>
    <div class="search inline-block">
        <div class="sort-text pull-left">
            <div class="m-l-sm">
                <select :style="{color: sort_by === '' ? '#595959' : ''}" id="select-sort" class="form-control" :data-placeholder="t_sort" v-model='sort_by'>
                    <option disabled value="">{{ t_sort }}</option>
                    <option v-for="(text, key) in fullSortablesList"
                            :value="key" style="color: rgb(103, 106, 108);"> {{ text }}
                    </option>
                </select>
            </div>
        </div>
        <button class="sort-dir pull-left btn form-control" type="button" @click="sort_dir = (sort_dir==='asc' && sort_by !== '') ? 'desc' : 'asc'">
            <i :class="['fa-regular', sort_dir==='asc'? 'fa-arrow-down' : 'fa-arrow-up']"></i>
        </button>
        <div class="search-text pull-left">
            <div class="m-l-sm">
                <input type="text" :placeholder="t_search" v-model="search" class="form-control">
            </div>
        </div>
        <div class="search-tags pull-left">
            <div class="m-l-sm">
                <chosen-multiselect id="select-tags" :trans-placeholder-multi="t_tags" v-model='tags'>
                    <option v-for="optiondata in fullTagList.data"
                            :value="optiondata.value" v-html="optiondata.text">
                    </option>
                </chosen-multiselect>
            </div>
        </div>
        <div class="search-types pull-left">
            <div class="m-l-sm">
                <chosen-multiselect id="select-types" :trans-placeholder-multi="t_type" v-model='types'>
                    <option v-for="optiondata in fullTypeList.data"
                            :value="optiondata.value">
                        {{optiondata.text }}
                    </option>
                </chosen-multiselect>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import toaster from "../../common/toaster";

    export default {
        data: function () {
            return {
                t_search: Lang.langGet("Search"),
                t_tags: Lang.langChoice("Tag|Tags", 2),
                t_type: Lang.langChoice("Type|Types", 2),
                t_sort: Lang.langGet("Sort by"),
                t_load_tags_failed: Lang.langGet("Failed to load tags from database."),
                t_load_types_failed: Lang.langGet("Failed to load filetypes from configuration."),
                search: '',
                tags: [],
                types: [],
                sort_by: '',
                fullTagList: {
                    data: []
                },
                fullTypeList: {
                    data: []
                },
                fullSortablesList: {
                    'name': Lang.langGet("Name"),
                    'type': Lang.langGet("Filetype"),
                    'size': Lang.langGet("Size"),
                    'date': Lang.langGet("Added"),
                },
                sort_dir: 'asc'
            }
        },
        watch: {
            search: debounce(function () {
                EaseEventBus.fire('startSearch', {keyword: this.search, tags: this.tags, types: this.types});
            }, 250),
            tags: function () {
                EaseEventBus.fire('startSearch', {keyword: this.search, tags: this.tags, types: this.types});
            },
            types: function () {
                EaseEventBus.fire('startSearch', {keyword: this.search, tags: this.tags, types: this.types});
            },
            sort_by: function () {
                EaseEventBus.fire('sortBy', {sort_by: this.sort_by, sort_dir: this.sort_dir});
            },
            sort_dir: function () {
                EaseEventBus.fire('sortBy', {sort_by: this.sort_by, sort_dir: this.sort_dir});
            }
        },
        methods: {
            loadTypes: function () {
                if (this.fullTypeList.data.length > 0) {
                    return;
                }

                axios.post('/content/mediapool/loadtypes', {
                    id: Laravel.activeProject
                }).then((response) => {
                    this.fullTypeList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_types_failed);
                });
            },
            loadTags: function () {
                axios.post('/content/mediapool/loadtags', {
                    id: Laravel.activeProject
                }).then((response) => {
                    let superTags = response.data.data.superTags;
                    _.each(superTags, (tag, key) => {
                        superTags[key].text = "<i class=\"far fa-sparkles\"></i> " + tag.text;
                    })
                    this.fullTagList.data = response.data.data.ordinaryTags.concat(superTags);
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_tags_failed);
                });
            }
        },
        mounted() {
            this.loadTypes();
            this.loadTags();

            EaseEventBus.listen('updateMedialist', () => {
                this.loadTags();
                EaseEventBus.fire('updateMedialistData', {keyword: this.search, tags: this.tags, types: this.types});
            });
        }
    }
</script>
